export const alertConstants = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  CLEAR: 'ALERT_CLEAR',
};
